
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/financial-services",
      function () {
        return require("private-next-pages/use-cases/financial-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/financial-services"])
      });
    }
  